<script setup lang="ts">
    import { LoadingState } from '~~/app/enums/LoadingState';

    defineProps<{
        loading: LoadingState;
    }>();
</script>

<template>
    <div class="fixed inset-0 z-[9999]">
        <div class="absolute inset-0 bg-white"></div>
        <div class="absolute inset-0 flex items-center justify-center z-[10000]">
            <div class="relative">
                <img
                    src="~/assets/logo.svg"
                    class="h-[40px] lg:h-[50px] fade-in"
                />
            </div>
            <div
                v-if="loading === LoadingState.PREPARING_ACCOUNT"
                class="absolute bottom-0 flex flex-col items-center justify-center gap-3 px-6 pb-12 text-sm text-center text-gray-600 lg:flex-row lg:text-base fade-in"
            >
                <svg
                    id="spinner"
                    class="shrink-0"
                    version="1.1"
                    viewBox="0 0 64 64"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        class="path-gradient"
                        cx="32"
                        cy="32"
                        r="28"
                        fill="none"
                        stroke="url(#sGD)"
                        stroke-width="8"
                    />
                    <path
                        class="path-solid"
                        d="M 32,4 A 28 28,0,0,0,32,60"
                        fill="none"
                        stroke="#000"
                        stroke-width="8"
                        stroke-linecap="round"
                    />

                    <defs>
                        <linearGradient
                            id="sGD"
                            gradientUnits="userSpaceOnUse"
                            x1="32"
                            y1="0"
                            x2="32"
                            y2="64"
                        >
                            <stop
                                stop-color="#000"
                                offset="0.1"
                                stop-opacity="0"
                                class="stop1"
                            ></stop>
                            <stop
                                stop-color="#000"
                                offset=".9"
                                stop-opacity="1"
                                class="stop2"
                            ></stop>
                        </linearGradient>
                    </defs>

                    <animateTransform
                        values="0,0,0;360,0,0"
                        attributeName="transform"
                        type="rotate"
                        repeatCount="indefinite"
                        dur="750ms"
                    ></animateTransform>
                </svg>
                <p>
                    {{ $t('loading_screen.preparing_account') }}
                </p>
            </div>
        </div>
    </div>
</template>

<style>
    #spinner {
        width: 20px;
    }

    #spinner #sGD stop {
        stop-color: currentColor;
    }

    #spinner .path-solid {
        stroke: currentColor;
    }
</style>
